            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">       
                <b-form  inline style="margin-bottom:15px" novalidate> 
                  <b-row style="width:100%;margin-bottom:20px"  v-if="dataForm[namePath].info_ingresos.id_list_forma!==1">                      
                    <sw-inputs
                          inputTabla="info_ingresos"
                          inputCampo="id_datos_razon"
                          inline
                          :md="4" :lg="4">
                        </sw-inputs>                     
                        <sw-inputs
                          inputTabla="info_ingresos"
                          inputCampo="id_list_forma"
                          inline                          
                          modalVariant="secondary"
                          modalTitle="Agregar forma de pago"
                          modalSize="sm"
                          :md="5" :lg="5">
                          <template v-slot:modal="modalInput">
                            <sw-modallistforma 
                              @cerrar="modalInput.modalInput.value=false">
                            </sw-modallistforma>
                          </template>
                        </sw-inputs>                          
                        <sw-inputs
                          class="col-lg-3 col-md-3 col-sm-12 d-none"
                          style="margin-top: 5px;"
                          inputTabla="info_ingresos"
                          inputCampo="label_consecutivo"
                          :showLabel="false"
                          inline>
                        </sw-inputs> 
                        <sw-inputs
                          inputTabla="info_ingresos"
                          inputCampo="descripcion"
                          inline
                          :md="12" :lg="12">
                        </sw-inputs>
                  </b-row>  
                  <b-row style="width:100%;margin-bottom:20px" v-if="dataForm[namePath].info_ingresos.id_list_forma===1">                      
                    <sw-inputs
                          inputTabla="info_ingresos"
                          inputCampo="id_datos_razon"
                          inline
                          :md="4" :lg="4">
                        </sw-inputs>                     
                        <sw-inputs
                          inputTabla="info_ingresos"
                          inputCampo="id_list_forma"
                          inline
                          modalVariant="secondary"
                          modalTitle="Agregar forma de pago"
                          modalSize="sm"
                          :md="5" :lg="5">
                          <template v-slot:modal="modalInput">
                            <sw-modallistforma 
                              @cerrar="modalInput.modalInput.value=false">
                            </sw-modallistforma>
                          </template>
                        </sw-inputs>                           
                        <sw-inputs
                          class="col-lg-3 col-md-3 col-sm-12 d-none"
                          style="margin-top: 5px;"
                          inputTabla="info_ingresos"
                          inputCampo="label_consecutivo"
                          :showLabel="false"
                          inline>
                        </sw-inputs>  
                        <b-col :md="4" :lg="4">
                        </b-col>                                          
                        <sw-inputs
                          inputTabla="info_ingresos"
                          inputCampo="id_list_cuentas"
                          inline
                          modalVariant="secondary"
                          modalTitle="Agregar cuenta"
                          modalSize="sm"
                          :md="5" :lg="5">
                          <template v-slot:modal="modalInput">
                            <sw-modallistcuentas
                              @cerrar="modalInput.modalInput.value=false">
                            </sw-modallistcuentas>
                          </template>
                        </sw-inputs>  
                        <b-col :md="3" :lg="3">
                        </b-col>     
                        <b-col :md="4" :lg="4">
                        </b-col>    
                        <sw-inputs
                          style="margin-bottom:10px"
                          inputTabla="info_ingresos"
                          inputCampo="consignacion"
                          inline
                          :md="5" :lg="5">
                        </sw-inputs>                
                        <sw-inputs
                          inputTabla="info_ingresos"
                          inputCampo="descripcion"
                          inline
                          :md="12" :lg="12">
                        </sw-inputs>                       
                  </b-row>
                  <b-row style="border: 1px dashed #888; width:100%; border-radius:5px; padding:10px 0">
                    <b-col md="6">
                        <span style="font-weight: 500;display:inline-block;width:80px">Contacto:</span> {{dataForm[namePath].info_ingresos.name}}<br>
                        <span style="font-weight: 500;display:inline-block;width:80px">Dirección:</span> {{dataForm[namePath].info_ingresos.direccion}} <br>
                        <span style="font-weight: 500;display:inline-block;width:80px">Teléfonos:</span> {{dataForm[namePath].info_ingresos.telefonos}}<br>
                    </b-col>  
                    <b-col md="6">
                        <span style="font-weight: 500;display:inline-block;width:100px">Documento:</span> {{dataForm[namePath].info_ingresos.documento}} <br>     
                        <span style="font-weight: 500;display:inline-block;width:100px">Correo:</span> {{dataForm[namePath].info_ingresos.email}} <br>                      
                        <span style="font-weight: 500;display:inline-block;width:100px"> Asesor:</span>  {{gettersDatalist('datos_asesor',dataForm[namePath].info_afiliacion.id_datos_asesor)[0].name}}<br>                        
                     </b-col> 
                  </b-row>  
                  <b-row style="border: 1px dashed #888; width:100%; border-radius:5px; padding:10px 0; margin-top:10px">
                    <b-col md="6" style="text-align:justify">
                        <span style="font-weight: 500;display:inline-block;width:80px; ">Concepto:</span> {{dataForm[namePath].info_ingresos.descripcion}} {{serviciosDescripcion}}
                    </b-col>  
                    <b-col md="3">
                        <span style="font-weight: 500;display:inline-block;width:100px">Valor:</span> {{dataForm[namePath].info_ingresos.valor}} <br>
                        <b-form-checkbox
                          @input="changeReporte"
                          v-model="valorreporte"
                          name="checkbox-1"
                          >
                          Solo reporte asesor
                        </b-form-checkbox>
                    </b-col> 
                    <b-col md="3">
                        <span style="font-weight: 500;display:inline-block;width:100px">Reporte:</span> {{dataForm[namePath].info_ingresos.reporte}} <br>
                        <b-form-checkbox
                          @input="changeCompleto"
                          v-model="reporte"
                          name="checkbox-1"
                          >
                          Reporte completo
                        </b-form-checkbox>
                    </b-col> 
                  </b-row>  
                  <b-row style="width:100%">                                
                    <sw-inputs
                      inputTabla="info_ingresos"
                      inputCampo="observacion"
                      :md="12" :lg="12">
                    </sw-inputs>
                  </b-row>    
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px -15px; padding: 0 0 15px">
         <b-row align-v="center" style="width:100%">
           <b-col :md="8" :lg="8" style=text-align:right>
              <b-form-checkbox
                v-if="namePath!=='afiliacion_servicios'"
                v-model="excell"
                name="checkbox-1"
                >
                Generar registro en excell
              </b-form-checkbox>
           </b-col>
           <b-col>             
            <sw-saveform
              :index="dataIndex[namePath]"
              nameBtn=""
              :invalid="invalid"
              :getBackendData="getBackendData"
              @save="save"
              >
            </sw-saveform>
           </b-col>
         </b-row>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwModallistforma  from '@/components/modals/list_forma.vue'
import SwModallistcuentas  from '@/components/modals/list_cuentas.vue'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform,
    SwModallistforma,
    SwModallistcuentas  
  },
  props: {
  },
  data()
  {
    return {
      valor: 0,
      reporte: false,
      valorreporte: false,
      valorReporte: 0,
      createdCycle: true,
      active: 1,
      serviciosDescripcion: '',
      saveEvent:false,
      ultimoDataForm: {},
      getBackendData: false,
      excell: true,
    }
  },
  async updated()
  {    
    await this.resetDataForm({state: 'info_ingresos/descripcion'})
  },
  async created(){
    this.ultimoDataForm = await this.deepCopy(this.dataForm[this.namePath])
    if(this.namePath==='afiliacion_nueva')
    {
      if(this.dataIndex[this.namePath]!==false)
      {
        await this.updateDataForm({state: 'datos_afiliado', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].datos_afiliado})
        await this.updateDataForm({state: 'info_afiliacion', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_afiliacion})
      }  
      else 
      {
        const await00 = this.resetDataForm({state: 'info_ingresos'})
        const await01 = this.updateDataIndex({ data: 10000})
        await Promise.all([await00,await01])
        let asesorData = this.gettersDatalist('datos_asesor',this.dataForm[this.namePath].info_afiliacion.id_datos_asesor)
        let j=0
        for (let i = 0; i < this.dataForm[this.namePath].servicios_nuevos.length; i++) {   
          if(this.dataForm[this.namePath].servicios_nuevos[i].name_list!=='' && this.dataForm[this.namePath].servicios_nuevos[i].name_list!==null)
          {
            if(this.dataForm[this.namePath].servicios_nuevos[i].name==='Riesgo')
            {             
              let razonData = this.gettersDatalist('datos_razon',this.dataForm[this.namePath].info_afiliacion.id_datos_razon)  
              this.serviciosDescripcion = this.serviciosDescripcion+' ARL '+this.gettersDatalist('list_arl',razonData[0].id_list_arl)[0].name 
            }  
            let nameLista = await this.gettersDatalist(this.dataForm[this.namePath].servicios_nuevos[i].name_list,this.dataForm[this.namePath].servicios_nuevos[i].id_list)[0]   
            this.serviciosDescripcion = this.serviciosDescripcion+' '+this.dataForm[this.namePath].servicios_nuevos[i].name+' '+nameLista.name 
          }
          else 
          { 
            this.serviciosDescripcion = this.serviciosDescripcion+' '+this.dataForm[this.namePath].servicios_nuevos[i].name
          }   
          this.valor = parseInt(this.dataForm[this.namePath].servicios_nuevos[i].afiliacion)+parseInt(this.valor)  
          if(this.dataForm[this.namePath].servicios_nuevos[i].name==='Riesgo')
          {
            this.valorReporte= this.valorReporte+parseInt(asesorData[0]['r'+this.dataForm[this.namePath].servicios_nuevos[i].id_list])
          }
          if(this.dataForm[this.namePath].servicios_nuevos[i].name==='Ccf')
          {
            this.valorReporte= this.valorReporte+parseInt(asesorData[0]['ccf'])
          }
          if(this.dataForm[this.namePath].servicios_nuevos[i].name==='Afp')
          {
            this.valorReporte= this.valorReporte+parseInt(asesorData[0]['afp'])
          }               
        } 
        for (let i = 0; i < this.dataForm[this.namePath].servicios_activos.length; i++) {
          this.valor = parseInt(this.dataForm[this.namePath].servicios_activos[i].afiliacion)+parseInt(this.valor) 
        }      
        const await20 = this.updateDataForm({state: 'info_ingresos/valor', data: this.valor})
        if(this.dataForm[this.namePath].info_afiliacion.id_datos_asesor===1)
        {
          this.updateDataForm({state: 'info_ingresos/reporte', data: this.valor})
          this.updateDataForm({state: 'afiliacion_registro/valor', data: this.valor})
          this.updateDataForm({state: 'afiliacion_registro/reporte', data: this.valor})
          this.updateDataForm({state: 'afiliacion_registro/comision', data: 0})
        }
        else
        {
          this.updateDataForm({state: 'info_ingresos/reporte', data: this.valorReporte})
          this.updateDataForm({state: 'afiliacion_registro/valor', data: this.valor})
          this.updateDataForm({state: 'afiliacion_registro/reporte', data: this.valorReporte})
          this.updateDataForm({state: 'afiliacion_registro/comision', data: this.valor-this.valorReporte<0 ? 0 : this.valor-this.valorReporte})
        }
        const await22 = this.updateDataForm({state: 'info_ingresos/id_datos_razon', data: this.dataForm[this.namePath].info_afiliacion.id_datos_razon})
        const await23 = this.updateDataForm({state: 'info_ingresos/consecutivo', data: 1552})
        const await24 = this.updateDataForm({state: 'info_ingresos/id_datos_asesor', data: this.dataForm[this.namePath].info_afiliacion.id_datos_asesor})
        const await25 = this.updateDataForm({state: 'info_ingresos/name', data: this.dataForm[this.namePath].datos_afiliado.name})
        const await26 = this.updateDataForm({state: 'info_ingresos/documento', data:  this.dataForm[this.namePath].datos_afiliado.documento})
        const await27 = this.updateDataForm({state: 'info_ingresos/direccion', data:  this.dataForm[this.namePath].datos_afiliado.direccion})
        const await28 = this.updateDataForm({state: 'info_ingresos/telefonos', data:  this.dataForm[this.namePath].datos_afiliado.telefonos})
        const await29 = this.updateDataForm({state: 'info_ingresos/email', data:  this.dataForm[this.namePath].datos_afiliado.email})
        const await30 = this.updateDataForm({state:'info_ingresos/fecha', data: this.fecha().fecha.minHoy})
        const await33 = this.updateDataForm({state: 'info_ingresos/id_list_documento', data: this.dataForm[this.namePath].datos_afiliado.id_list_documento})
        
        await Promise.all([await20,await22,await23,await24,await25,await26,await27,await28,await29,await30,await33])
       
     } 
    } 
    if(this.namePath==='afiliacion_servicios')
    {
      await this.resetDataForm({state: 'info_ingresos'})
      this.updateDataIndex({data: 10000})
      
       let asesorData = this.gettersDatalist('datos_asesor',this.dataForm[this.namePath].info_afiliacion.id_datos_asesor)
      let valor=0
      let j=0
      for (let i = 0; i < this.dataForm[this.namePath].servicios_nuevos.length; i++) {   
          if(this.dataForm[this.namePath].servicios_nuevos[i].name_list!=='' && this.dataForm[this.namePath].servicios_nuevos[i].name_list!==null)
          {
            let nameLista = await this.gettersDatalist(this.dataForm[this.namePath].servicios_nuevos[i].name_list,this.dataForm[this.namePath].servicios_nuevos[i].id_list)[0]   
            this.serviciosDescripcion = this.serviciosDescripcion+' '+this.dataForm[this.namePath].servicios_nuevos[i].name+' '+nameLista.name 
          }
          else 
          { 
            this.serviciosDescripcion = this.serviciosDescripcion+' '+this.dataForm[this.namePath].servicios_nuevos[i].name
          } 
          this.valor = parseInt(this.dataForm[this.namePath].servicios_nuevos[i].afiliacion)+parseInt(this.valor)  
          if(this.dataForm[this.namePath].servicios_nuevos[i].name==='Riesgo')
          {
            this.valorReporte= this.valorReporte+parseInt(asesorData[0]['r'+this.dataForm[this.namePath].servicios_nuevos[i].id_list])
          }
          if(this.dataForm[this.namePath].servicios_nuevos[i].name==='Ccf')
          {
            this.valorReporte= this.valorReporte+parseInt(asesorData[0]['ccf'])
          }
          if(this.dataForm[this.namePath].servicios_nuevos[i].name==='Afp')
          {
            this.valorReporte= this.valorReporte+parseInt(asesorData[0]['afp'])
          }                    
            
      }       
      const await20 = this.updateDataForm({state: 'info_ingresos/valor', data: this.valor})
      const await21 =  this.updateDataForm({state: 'info_ingresos/consecutivo', data: 1552})
      if(this.dataForm[this.namePath].info_afiliacion.id_datos_asesor===1)
      {
        this.updateDataForm({state: 'info_ingresos/reporte', data: this.valor})
        this.updateDataForm({state: 'afiliacion_registro/valor', data: this.valor})
        this.updateDataForm({state: 'afiliacion_registro/reporte', data: this.valor})
        this.updateDataForm({state: 'afiliacion_registro/comision', data: 0})
      }
      else
      {
        this.updateDataForm({state: 'info_ingresos/reporte', data: this.valorReporte})
        this.updateDataForm({state: 'afiliacion_registro/valor', data: this.valor})
        this.updateDataForm({state: 'afiliacion_registro/reporte', data: this.valorReporte})
        this.updateDataForm({state: 'afiliacion_registro/comision', data: this.valor-this.valorReporte<0 ? 0 : this.valor-this.valorReporte})
      }
      const await23 =  this.updateDataForm({state: 'info_ingresos/id_datos_asesor', data: this.dataForm[this.namePath].info_afiliacion.id_datos_asesor})
      const await24 =  this.updateDataForm({state: 'info_ingresos/id_datos_razon', data: this.dataForm[this.namePath].info_afiliacion.id_datos_razon})
      const await25 =  this.updateDataForm({state: 'info_ingresos/name', data: this.dataForm[this.namePath].datos_afiliado.name})
      const await26 =  this.updateDataForm({state: 'info_ingresos/documento', data:  this.dataForm[this.namePath].datos_afiliado.documento})
      const await27 =  this.updateDataForm({state: 'info_ingresos/direccion', data:  this.dataForm[this.namePath].datos_afiliado.direccion})
      const await28 =  this.updateDataForm({state: 'info_ingresos/telefonos', data:  this.dataForm[this.namePath].datos_afiliado.telefonos})
      const await29 =  this.updateDataForm({state: 'info_ingresos/email', data:  this.dataForm[this.namePath].datos_afiliado.email})
      const await30 =  this.updateDataForm({state: 'info_ingresos/fecha', data: this.fecha().fecha.minHoy})
      const await31 = this.updateDataForm({state: 'info_ingresos/id_list_documento', data: this.dataForm[this.namePath].datos_afiliado.id_list_documento})
      await Promise.all([await20,await21,await23,await24,await25,await26,await27,await28,await29,await30,await31])
    }
    if(this.namePath==='informes_afiliaciones')
    {
      await this.updateDataForm({data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]]})
      await this.resetDataForm({state: 'info_ingresos'})
      await this.updateDataIndex({data: 10000})
      let asesorData = this.gettersDatalist('datos_asesor',this.dataForm[this.namePath].info_afiliacion.id_datos_asesor)

      let valor=0
      let j=0
      for (let i = 0; i < this.dataForm[this.namePath].servicios_nuevos.length; i++) {   
          if(this.dataForm[this.namePath].servicios_nuevos[i].name_list!=='' && this.dataForm[this.namePath].servicios_nuevos[i].name_list!==null)
          {
            let nameLista = await this.gettersDatalist(this.dataForm[this.namePath].servicios_nuevos[i].name_list,this.dataForm[this.namePath].servicios_nuevos[i].id_list)[0]   
            this.serviciosDescripcion = this.serviciosDescripcion+' '+this.dataForm[this.namePath].servicios_nuevos[i].name+' '+nameLista.name 
          }
          else 
          { 
            this.serviciosDescripcion = this.serviciosDescripcion+' '+this.dataForm[this.namePath].servicios_nuevos[i].name
          }   
          this.valor = parseInt(this.dataForm[this.namePath].servicios_nuevos[i].afiliacion)+parseInt(this.valor)  
          if(this.dataForm[this.namePath].servicios_nuevos[i].name==='Riesgo')
          {
            this.valorReporte= this.valorReporte+parseInt(asesorData[0]['r'+this.dataForm[this.namePath].servicios_nuevos[i].id_list])
          }
          if(this.dataForm[this.namePath].servicios_nuevos[i].name==='Ccf')
          {
            this.valorReporte= this.valorReporte+parseInt(asesorData[0]['ccf'])
          }
          if(this.dataForm[this.namePath].servicios_nuevos[i].name==='Afp')
          {
            this.valorReporte= this.valorReporte+parseInt(asesorData[0]['afp'])
          }               
        } 
        for (let i = 0; i < this.dataForm[this.namePath].servicios_activos.length; i++) {
          this.valor = parseInt(this.dataForm[this.namePath].servicios_activos[i].afiliacion)+parseInt(this.valor) 
        }      
        const await20 = this.updateDataForm({state: 'info_ingresos/valor', data: this.valor})

      if(this.dataForm[this.namePath].info_afiliacion.id_datos_asesor===1)
      {
        this.updateDataForm({state: 'info_ingresos/reporte', data: this.valor})
        this.updateDataForm({state: 'afiliacion_registro/valor', data: this.valor})
        this.updateDataForm({state: 'afiliacion_registro/reporte', data: this.valor})
        this.updateDataForm({state: 'afiliacion_registro/comision', data: 0})
      }
      else
      {
        this.updateDataForm({state: 'info_ingresos/reporte', data: this.valorReporte})
        this.updateDataForm({state: 'afiliacion_registro/valor', data: this.valor})
        this.updateDataForm({state: 'afiliacion_registro/reporte', data: this.valorReporte})
        this.updateDataForm({state: 'afiliacion_registro/comision', data: this.valor-this.valorReporte<0 ? 0 : this.valor-this.valorReporte})
      }
      const await23 = this.updateDataForm({state: 'info_ingresos/id_datos_asesor', data: this.dataForm[this.namePath].info_afiliacion.id_datos_asesor})
      const await24 = this.updateDataForm({state: 'info_ingresos/id_datos_razon', data: this.dataForm[this.namePath].info_afiliacion.id_datos_razon})
      const await25 = this.updateDataForm({state: 'info_ingresos/name', data: this.dataForm[this.namePath].datos_afiliado.name})
      const await26 = this.updateDataForm({state: 'info_ingresos/documento', data:  this.dataForm[this.namePath].datos_afiliado.documento})
      const await27 = this.updateDataForm({state: 'info_ingresos/direccion', data:  this.dataForm[this.namePath].datos_afiliado.direccion})
      const await28 = this.updateDataForm({state: 'info_ingresos/telefonos', data:  this.dataForm[this.namePath].datos_afiliado.telefonos})
      const await29 = this.updateDataForm({state: 'info_ingresos/email', data:  this.dataForm[this.namePath].datos_afiliado.email})
      const await30 = this.updateDataForm({state:'info_ingresos/fecha', data: this.fecha().fecha.minHoy})
      const await31 = this.updateDataForm({state: 'info_ingresos/id_list_documento', data: this.dataForm[this.namePath].datos_afiliado.id_list_documento})

      await Promise.all([await20,await23,await24,await25,await26,await27,await28,await29,await30,await31])
    }
    if(this.namePath==='servicios_afiliacion')
    {
      await this.resetDataForm({state: 'info_ingresos'})
      this.updateDataIndex({data: 10000})
      
       let asesorData = this.gettersDatalist('datos_asesor',this.dataForm[this.namePath].info_afiliacion.id_datos_asesor)
      let valor=0
      let j=0
      for (let i = 0; i < this.dataForm[this.namePath].servicios_nuevos.length; i++) {   
          this.serviciosDescripcion = this.serviciosDescripcion+' '+this.dataForm[this.namePath].servicios_nuevos[i].name          
          this.valor = parseInt(this.dataForm[this.namePath].servicios_nuevos[i].afiliacion)+parseInt(this.valor)            
      }     
      this.valorReporte=this.valor  
      const await14 = this.updateDataForm({state: 'info_ingresos/valor', data: this.valor})
      const await15 =  this.updateDataForm({state: 'info_ingresos/consecutivo', data: 1552})     
      const await16 = this.updateDataForm({state: 'info_ingresos/reporte', data: this.valor})  
      const await17 = this.updateDataForm({state: 'info_afiliacion/servicios', data: 1})
      const await18 = this.updateDataForm({state: 'datos_afiliado/servicios', data: 1})
      const await19 = this.updateDataForm({state: 'info_ingresos/servicios', data: 1})
      const await20 = this.updateDataForm({state: 'afiliacion_registro/valor', data: this.valor})
      const await21 = this.updateDataForm({state: 'afiliacion_registro/reporte', data: this.valor})
      const await22 = this.updateDataForm({state: 'afiliacion_registro/comision', data: 0})     
      const await23 =  this.updateDataForm({state: 'info_ingresos/id_datos_asesor', data: this.dataForm[this.namePath].info_afiliacion.id_datos_asesor})
      const await24 =  this.updateDataForm({state: 'info_ingresos/id_datos_razon', data: this.dataForm[this.namePath].info_afiliacion.id_datos_razon})
      const await25 =  this.updateDataForm({state: 'info_ingresos/name', data: this.dataForm[this.namePath].datos_afiliado.name})
      const await26 =  this.updateDataForm({state: 'info_ingresos/documento', data:  this.dataForm[this.namePath].datos_afiliado.documento})
      const await27 =  this.updateDataForm({state: 'info_ingresos/direccion', data:  this.dataForm[this.namePath].datos_afiliado.direccion})
      const await28 =  this.updateDataForm({state: 'info_ingresos/telefonos', data:  this.dataForm[this.namePath].datos_afiliado.telefonos})
      const await29 =  this.updateDataForm({state: 'info_ingresos/email', data:  this.dataForm[this.namePath].datos_afiliado.email})
      const await30 =  this.updateDataForm({state: 'info_ingresos/fecha', data: this.fecha().fecha.minHoy})
      const await31 = this.updateDataForm({state: 'info_ingresos/id_list_documento', data: this.dataForm[this.namePath].datos_afiliado.id_list_documento})
      await Promise.all([await14,await15,await16,await17,await18,await19,await20,await21,await22,await23,await24,await25,await26,await27,await28,await29,await30,await31])
    }
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  destroyed()
  {
      this.resetDataIndex()
      this.resetDataPost()
  },
  computed: { 
  },
  methods: {
    async changeReporte()
    {
      if(this.valorreporte===true && this.dataForm[this.namePath].info_afiliacion.id_datos_asesor!==1)
      {      
        await this.updateDataForm({state: 'info_ingresos/valor', data: this.valorReporte})
        await this.updateDataForm({state: 'afiliacion_registro/valor', data: this.valorReporte})
        await this.updateDataForm({state: 'afiliacion_registro/reporte', data: this.valorReporte})
      await this.updateDataForm({state: 'afiliacion_registro/comision', data: 0})
        return true
      }
      await this.updateDataForm({state: 'info_ingresos/valor', data: this.valor})
      await this.updateDataForm({state: 'afiliacion_registro/valor', data: this.valor})
      await this.updateDataForm({state: 'afiliacion_registro/reporte', data: this.valorReporte})
      await this.updateDataForm({state: 'afiliacion_registro/comision', data: this.valor-this.valorReporte<0 ? 0 : this.valor-this.valorReporte})
      return true
    },
    async changeCompleto()
    {
      if(this.reporte===true)
      {      
        await this.updateDataForm({state: 'info_ingresos/reporte', data: this.valor})
        await this.updateDataForm({state: 'afiliacion_registro/reporte', data: this.valorReporte})
        await this.updateDataForm({state: 'afiliacion_registro/comision', data: 0})
        return true
      }
      await this.updateDataForm({state: 'info_ingresos/reporte', data: this.valorReporte})
      await this.updateDataForm({state: 'afiliacion_registro/reporte', data: this.valorReporte})
      await this.updateDataForm({state: 'afiliacion_registro/comision', data: this.valor-this.valorReporte<0 ? 0 : this.valor-this.valorReporte})

      return true
    },
    async save(event)
    {
      if(this.saveEvent)
      {
        this.resetDataPost({state: 'data'})
        let info_ingresos=this.deepCopy(this.dataForm[this.namePath].info_ingresos)
        await this.updateDataForm({data: this.ultimoDataForm})
        await this.updateDataForm({state: 'info_ingresos', data: info_ingresos})
        this.saveEvent=false      
      }
      if(this.saveEvent===false)
      {  
        this.getBackendData=true
        // actualizar predeterminado de descripcion
        if(this.dataForm[this.namePath].info_ingresos.id_list_forma===2 || this.dataForm[this.namePath].info_ingresos.id_list_forma===5)
        {
          await this.updateDataForm({state: 'info_ingresos/fecha', data: null})
        }
        
        await this.updateDataForm({state: 'info_ingresos/descripcion', data: this.dataForm[this.namePath].info_ingresos.descripcion+this.serviciosDescripcion})
        					
        this.$emit('save',{save:event.save, ftn: 'afiliacionFtn', excell: this.excell })
        this.saveEvent=true 
        this.getBackendData=false    
        return true 
      }
    }
  }
}
</script>
<style>
</style>